import { render, staticRenderFns } from "./CreateManufacturingLogbookreferenceSheet.vue?vue&type=template&id=60f31531&scoped=true"
import script from "./CreateManufacturingLogbookreferenceSheet.vue?vue&type=script&lang=js"
export * from "./CreateManufacturingLogbookreferenceSheet.vue?vue&type=script&lang=js"
import style0 from "./CreateManufacturingLogbookreferenceSheet.vue?vue&type=style&index=0&id=60f31531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f31531",
  null
  
)

export default component.exports